import { useLanguage } from '../hooks';

// Simple translation hook for kit components
export function useTranslation() {
  const { language, strings } = useLanguage();
  // t: if key exists in strings, return translation, else return key as fallback
  function t(key) {
    if (!key || typeof key !== 'string') return key;
    return strings[key] || key;
  }
  return { t, language };
}
